import { useState, useEffect } from 'react';
import { Shield, Check } from 'lucide-react';
import { roleAPI } from '../../services/api';

const ALL_PAGES = [
  { key:'view_dashboard',      label:'Dashboard',        desc:'Main dashboard & KPIs' },
  { key:'view_live_data',      label:'Live Data',         desc:'Real-time weight feed' },
  { key:'view_weight_history', label:'Weight History',    desc:'Historical weight records' },
  { key:'add_weight_entry',    label:'Add Weight Entry',  desc:'Create new weight checks' },
  { key:'export_data',         label:'Export Data',       desc:'Download CSV/PDF reports' },
  { key:'manage_users',        label:'Manage Users',      desc:'Add/edit client users' },
];

// Fixed 2 roles — Operator ani Vendor
const ROLE_COLORS = {
  'Manager': '#3b82f6',
};

export default function CompanyRoles() {
  const [roles, setRoles]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    roleAPI.list()
      .then(r => {
        // Fakt Operator ani Vendor dikhav
        const filtered = (r.data || []).filter(role =>
          role.name === 'Manager'
        );
        setRoles(filtered);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding:28, color:'var(--text2)' }}>Loading...</div>;

  return (
    <div style={{ padding:28 }}>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:20, fontWeight:700 }}>Roles & Permissions</h1>
        <p style={{ color:'var(--text2)', fontSize:13, marginTop:2 }}>
          1 Role in System — Manager
        </p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))', gap:16 }}>
        {roles.length === 0 && (
          <div style={{ gridColumn:'1/-1', textAlign:'center', padding:48, color:'var(--text3)', fontSize:13 }}>
            Selecting a Role will auto-select its pages — you can still change them
          </div>
        )}
        {roles.map(role => {
          const color = ROLE_COLORS[role.name] || 'var(--accent)';
          return (
            <div key={role.id} className="card" style={{ position:'relative', overflow:'hidden' }}>
              {/* Top color bar */}
              <div style={{ position:'absolute', top:0, left:0, right:0, height:4, background:color, borderRadius:'8px 8px 0 0' }} />

              {/* Role header */}
              <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20, paddingTop:8 }}>
                <div style={{
                  width:40, height:40, borderRadius:12,
                  background:`${color}22`,
                  border:`1.5px solid ${color}55`,
                  display:'flex', alignItems:'center', justifyContent:'center'
                }}>
                  <Shield size={18} color={color} />
                </div>
                <div>
                  <div style={{ fontWeight:700, fontSize:15 }}>{role.name}</div>
                  <div style={{ fontSize:11, color:'var(--text3)', marginTop:2 }}>
                    {(role.permissions||[]).length} pages accessible
                  </div>
                </div>
                <div style={{ marginLeft:'auto' }}>
                  <span style={{
                    fontSize:11, padding:'4px 10px', borderRadius:20,
                    background:`${color}18`, color:color,
                    border:`1px solid ${color}44`, fontWeight:600
                  }}>
                    {role.name}
                  </span>
                </div>
              </div>

              {/* Pages list */}
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                {ALL_PAGES.map(p => {
                  const has = (role.permissions||[]).includes(p.key);
                  return (
                    <div key={p.key} style={{
                      display:'flex', alignItems:'center', gap:10,
                      padding:'8px 12px', borderRadius:8,
                      background: has ? `${color}0f` : 'transparent',
                      border: `1px solid ${has ? color + '33' : 'var(--border)'}`,
                    }}>
                      <div style={{
                        width:20, height:20, borderRadius:6, flexShrink:0,
                        display:'flex', alignItems:'center', justifyContent:'center',
                        background: has ? color : 'var(--surface2)',
                        border: `1.5px solid ${has ? color : 'var(--border2)'}`,
                      }}>
                        {has && <Check size={12} color="#fff" strokeWidth={3} />}
                      </div>
                      <div style={{ flex:1 }}>
                        <span style={{
                          fontSize:13,
                          color: has ? 'var(--text)' : 'var(--text3)',
                          fontWeight: has ? 600 : 400
                        }}>
                          {p.label}
                        </span>
                        <span style={{ fontSize:11, color:'var(--text3)', marginLeft:6 }}>
                          — {p.desc}
                        </span>
                      </div>
                      {has && (
                        <span style={{ fontSize:10, color:color, fontWeight:600 }}>✓ Access</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}